import React from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody } from 'reactstrap';
import { default as AgentItemDetails } from './details';

import './styles.scss';

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({ openModal: !prevState.openModal }));
  };

  render() {
    const { name, businessName, role, image, code } = this.props;
    const { openModal } = this.state;

    return (
      <>
        <div className="activity-box-w" onClick={this.toggleModal}>
          <div className="activity-time" />
          <div className="activity-box">
            <div className="activity-avatar  with-status status-green">
              <img alt="Immagine" src={image} />
            </div>
            <div className="activity-info">
              <div className="activity-role">{businessName}</div>
              <strong className="activity-title">
                {role.toUpperCase()}: {name}
              </strong>
            </div>
          </div>
        </div>
        <Modal
          isOpen={openModal}
          toggle={this.toggle}
          className="modal-lg modal-centered"
        >
          <div className="modal-header">
            <h5
              className="modal-title"
              toggle={this.toggle}
              style={{ textTransform: 'capitalize' }}
            >
              {role.toLowerCase()}: {name.toLowerCase()}
            </h5>
            <button className="close" type="button" onClick={this.toggleModal}>
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <ModalBody className="agent-modal-body">
            {openModal && <AgentItemDetails code={code} />}
          </ModalBody>
        </Modal>
      </>
    );
  }
}

Item.defaultProps = {
  image:
    'https://www.gormankelly.com.au/wp-content/uploads/2019/03/Placeholder-Team-Image.jpg',
};

Item.propTypes = {
  role: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  businessName: PropTypes.string.isRequired,
  image: PropTypes.string,
  code: PropTypes.number.isRequired,
};

export default Item;
